import { PureComponent } from "react";
import BaseTemplate from "/components/templates/base-template";
import { MAIN_ID } from "constants/element-ids";

import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";

import { DirectoryComponent, DirectoryHeaderComponent } from "/components/core/directory";

import { THUMBNAILS_TYPES } from "/constants/thumbnails-types";

import { StyledDirectoryTemplateComponent } from "./directory-images-template.scss";

import { itemFilterValidator } from "/services/directories-service";

import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component"; //new for monday 2.0
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component"; // //new for monday 2.0

export default class DirectoryImagesTemplate extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: null
    };

    this.onSearchChange = this.onSearchChange.bind(this);
    this.filterValidator = this.filterValidator.bind(this);
  }

  onSearchChange(value) {
    this.setState({ searchValue: value });
  }

  filterValidator(item) {
    const { searchValue } = this.state;
    return itemFilterValidator(item, searchValue);
  }

  render() {
    const { exitPopup } = this.props;
    const { header, listData, socialButtons, topBanner, exitPopupConfig } = this.props.pageConfig;

    const { searchValue } = this.state;

    return (
      <BaseTemplate {...this.props} {...this.props.pageConfig}>
        <StyledDirectoryTemplateComponent className="directory-template-component">
          <BaseHeaderComponent
            allowSocialButtons={socialButtons && socialButtons.show}
            socialButtonsColor={socialButtons && socialButtons.color}
            socialButtonBlogStyle={socialButtons && socialButtons.blogStyle}
            topBanner={topBanner}
            maxWidth="100%"
            showMenu={true}
            headerBackgroundColor="white"
          />

          {header && (
            <DirectoryHeaderComponent {...header} searchValue={searchValue} onSearchChange={this.onSearchChange} />
          )}

          <main className="directory-component-wrapper" id={MAIN_ID}>
            <DirectoryComponent
              filterTerm={searchValue}
              tuhmbnailsListData={listData}
              thumbnailType={THUMBNAILS_TYPES.BACKGROUND_IMAGE}
              filterValidator={this.filterValidator}
            />
          </main>

          <LongFooterComponent />

          <CoreAddonsComponent exitPopup={exitPopup} exitPopupConfig={exitPopupConfig} />
        </StyledDirectoryTemplateComponent>
      </BaseTemplate>
    );
  }
}

DirectoryImagesTemplate.defaultProps = {
  exitPopup: true,
  pageConfig: {
    header: {
      color: "brand-red",
      text: "sdkhjdsjhkds",
      height: "360px",
      img: "/static/img/strips/strip-computer-coffee.png"
    },

    listData: [],

    footerSignup: {
      title: "Start using monday.com today",
      subtitle: "Try it now for free / No credit card needed"
    }
  }
};
